import { render, staticRenderFns } from "./PointOrderList.vue?vue&type=template&id=6c4999ee&scoped=true"
import script from "./PointOrderList.vue?vue&type=script&lang=js"
export * from "./PointOrderList.vue?vue&type=script&lang=js"
import style0 from "./PointOrderList.vue?vue&type=style&index=0&id=6c4999ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4999ee",
  null
  
)

export default component.exports